import L from 'leaflet';

export const CustomColorPicker = L.Control.extend({
  options: {
    position: 'topleft',
    defaultColor: '#000000',
  },
  onAdd() {
    const container = L.DomUtil.create(
      'div',
      'leaflet-bar leaflet-control leaflet-control-custom custom-draw-color-picker',
    );

    const anchor = L.DomUtil.create('a');
    anchor.title = 'Change drawing color';

    const input = L.DomUtil.create('input', 'color-picker-control');
    input.type = 'color';
    input.id = 'customColorPicker';
    input.value = this.options.defaultColor;

    anchor.appendChild(input);
    container.appendChild(anchor);

    return container;
  },
});
